function listDalleSelected(dalles, polygon) {
  let listDalle = [];

  dalles.forEach((dalle) => {
    if (dalle.values_.properties.polygon == polygon.polygon.values_.id) {
      lsitDalle.push(dalle);
    }
  });

  return listDalle;
}

function getDalleSelected(dalleSelect, polygon) {
  let listDalleInPolygon = { mns: [], mnt: [], mnh: [] };

  listDalleInPolygon.mns = listDalleSelected(dalleSelect.mns, polygon);
  listDalleInPolygon.mnt = listDalleSelected(dalleSelect.mnt, polygon);
  listDalleInPolygon.mnh = listDalleSelected(dalleSelect.mnh, polygon);

  return listDalleInPolygon;
}

function dalleInPolygon(polygon, dalleSelect) {
  // fonction qui permet de lister les dalles

  // liste ou on stockera les dalles sélctionné du polygon
  let listDalleSelectedInPolygon = getDalleSelected(dalleSelect, polygon);
  // on regarde si il y'a des dalles dans le polygon, si il n'y en a pas alors on return false il faudra supprimer le polygon
  if (listDalleSelectedInPolygon.mns.length > 0) {
    return listDalleSelectedInPolygon;
    // sinon on laisse le polygon ouvert et on affiche les dalles de ce polygon
  } else {
    return false;
  }
}

function isPolygonWithDalle(dalle, polygonSelect) {
  polygonSelect.forEach((polygon) => {
    if (dalle.values_.properties.polygon == polygon.polygon.values_.id) {
        return true
    }
  });

  return false
}

const handleTelechargement = (contenu, title) => {
  // fonction qui va permettre de telecharger le fichier txt avec son contenu
  
  // Créer un objet Blob avec le contenu texte
  const blob = new Blob([contenu], { type: "text/plain" });
  // Créer une URL pour le Blob
  const blobUrl = URL.createObjectURL(blob);
  // Créer un lien pour le téléchargement du fichier
  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = title;
  a.style.display = "none";
  document.body.appendChild(a);
  // Déclencher le téléchargement
  a.click();
  // Nettoyer après le téléchargement
  URL.revokeObjectURL(blobUrl);
  document.body.removeChild(a);
};





export { dalleInPolygon, isPolygonWithDalle, handleTelechargement };
